import { BaseModel } from 'app/core/models/base.model';

export class MultimediaCDN extends BaseModel {
	mediaBase64: string;
	url: string;
	mimeType: string;
}
